import { space } from '../spark/tokens';
export default {
  modalSettings: {
    base: {
      /** `transitionTimeout` must be specified as a number (i.e. not as a string) in msec without unit e.g. 300 for 0.3s or 5000 for 5s */
      transitionTimeout: 300,
      titleType: 'H6',
      contentType: 'Body1'
    }
  },
  wrapper: {
    base: {
      backgroundColor: 'grey-0',
      p: '20px',
      display: 'flex',
      flexDirection: 'column',
      transition: 'transform 300ms ease',
      variant: 'spark.base.wrapper'
    },
    variants: {
      initial: {
        variant: 'spark.element.modal.wrapper.base',
        width: ['90%', '425px', '608px'],
        position: 'relative',
        maxHeight: ["calc(85vh - ".concat(space.md, "px)"), '75vh'],
        minHeight: ['230px', '200px', '210px'],
        mx: 'auto',
        top: '50%',
        transform: 'translateY(-50%) scale(0)'
      },
      active: {
        variant: 'spark.element.modal.wrapper.variants.initial',
        transform: 'translateY(-50%) scale(1)'
      }
    }
  },
  close: {
    base: {
      marginBottom: ['0px', '20px']
    }
  },
  title: {
    base: {
      marginBottom: '20px'
    }
  },
  content: {
    base: {
      overflowY: 'auto',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '::-webkit-scrollbar': {
        display: 'none'
      }
    }
  },
  closeBtn: {
    base: {
      display: 'block',
      mr: ['-20px', '0'],
      ml: 'auto',
      position: 'relative',
      width: ['44px', '24px'],
      height: ['44px', '24px'],
      p: 0,
      border: 'none',
      cursor: 'pointer',
      color: 'unset',
      backgroundColor: 'transparent',
      appearance: 'none'
    }
  },
  closeImage: {
    base: {
      width: '24px',
      height: '24px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  footer: {
    base: {
      pt: '20px'
    }
  }
};